import React, {Component} from 'react';
import {connect} from 'react-redux';
import {bindActionCreators} from 'redux';
import {getSpotsFromFilters, getAllSpotsFromSelectedFilter} from '../../utils';
import {clearFilters} from '../../actions/filters';

class FilterBar extends Component {

  render() {
    const {availableFilteredSpots, allSpotsForFilter} = this.props;

    return (
      <div className="panel panel-filter-view">
        <img src="assets/images/sprite-icons/marker-pin-filtered.png" srcSet="assets/images/sprite-icons/marker-pin-filtered.png 1x, assets/images/sprite-icons/marker-pin-filtered@2x.png 2x" alt="" />&nbsp;
        {`${availableFilteredSpots.length}/${allSpotsForFilter.length}`} matches available
        <a href="#" className="pull-right" onClick={this.props.clearFilters}>
          <i className="fa fa-trash" />&nbsp;
          Clear filters
        </a>
      </div>
    );
  }

}

const mapStateToProps = (state) => {
  return {
    availableFilteredSpots: getSpotsFromFilters(),
    allSpotsForFilter: getAllSpotsFromSelectedFilter()
  };
};

const mapDispatchToProps = (dispatch) => {
  return bindActionCreators({clearFilters}, dispatch);
};

export default connect(mapStateToProps, mapDispatchToProps)(FilterBar);


// WEBPACK FOOTER //
// ./src/containers/NavOptions/FilterBar.js